// extracted by mini-css-extract-plugin
export default {"image":"logo_image__kMiQ0"};